import { ChangeEvent, useState } from "react"

export function usePopover(defaultOpen = false) {
  const [open, setOpen] = useState(defaultOpen)

  return {
    open,
    setOpen,
  }
}

export function useInput(defaultValue?: string) {
  const [val, setVal] = useState(defaultValue || "")

  return {
    val,
    setVal,
    bindings: {
      onChange: (e: ChangeEvent<HTMLInputElement>) => setVal(e.target.value),
      value: val,
    },
  }
}

/**
 * @deprecated
 */
export function useSwapInput() {
  const [val, setVal] = useState<bigint>()

  return {
    val,
    setVal,
    reset: () => setVal(undefined),
    bindings: {
      setVal,
      val,
    },
  }
}
